var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePlantProjectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.48,37.48v-1c0-3.66,0-7.33,0-11a3.39,3.39,0,0,1,1.08-2.6Q25.46,17,31.33,11.1A3.53,3.53,0,0,1,34,10q20.93,0,41.84,0a5.3,5.3,0,0,1,5.68,5.66q0,10.33,0,20.67v1.14c1.11,0,2.18,0,3.25,0a5.3,5.3,0,0,1,5.16,4.36,5.43,5.43,0,0,1,.07,1V84.59A5.28,5.28,0,0,1,84.57,90H15.4A5.29,5.29,0,0,1,10,84.56V42.9a5.27,5.27,0,0,1,5.25-5.41C16.28,37.45,17.31,37.48,18.48,37.48Zm57.64,0V15.39H36.27v1c0,2.8,0,5.61,0,8.41a2.78,2.78,0,0,1-3.07,3H24.78c-.3,0-.59,0-.89,0v9.63c.37,0,.67,0,1,0a11.81,11.81,0,0,1,2.31.15,5.27,5.27,0,0,1,4.14,5.25c0,2.13,0,4.26,0,6.41H68.68c0-2.16,0-4.26,0-6.37A5.32,5.32,0,0,1,74,37.48C74.7,37.46,75.39,37.48,76.12,37.48ZM50,78.59a8.92,8.92,0,1,0-8.94-9A9,9,0,0,0,50,78.59ZM27.92,22.33h2.86V19.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,29c2.55,0,5.1,0,7.65,0a2.75,2.75,0,0,1,2.66,1.89,2.53,2.53,0,0,1-1,2.93,3.7,3.7,0,0,1-1.79.54q-7.53.06-15.06,0a2.7,2.7,0,1,1,0-5.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,26c-2.52,0-5,0-7.57,0a2.67,2.67,0,1,1,0-5.32H57.63a2.66,2.66,0,1,1,0,5.32C55.08,26,52.53,26,50,26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,37.47c2.47,0,4.94.05,7.4,0a2.7,2.7,0,1,1,0,5.37H42.35a2.67,2.67,0,0,1-2.74-2.29,2.58,2.58,0,0,1,1.72-2.88,4.08,4.08,0,0,1,1.3-.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.65,69.68A3.65,3.65,0,1,1,50,66,3.7,3.7,0,0,1,53.65,69.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePlantProjectWhite);
export default __webpack_public_path__ + "static/media/createPlantProject_white.9dd64586ba0e7b4a9cb4e00c94084aed.svg";
export { ForwardRef as ReactComponent };